import { render } from "./EnrollmentCollection.vue?vue&type=template&id=5cae8885&ts=true"
import script from "./EnrollmentCollection.vue?vue&type=script&lang=ts"
export * from "./EnrollmentCollection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__